module.exports = __webpack_public_path__ + "img/49-image-2@2x.479864a6.png";